angular.module("app").controller('TestController', TestController);

TestController.$inject = [];

function TestController() {
	var vm = this;
	
	vm.text = "Hello Angular";
}